export const PAGINACAO_TAMANHOS = [
    {'pt': 'pq', 'en': 'sm'}, 
    {'pt': '', 'en': ''}, 
    {'pt': 'gd', 'en': 'lg'}, 
    {'pt': 'bc', 'en': 'block'}, 
];